function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 8.39062L20.1325 12.5856L15.9375 16.7805",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35938 3.35938V9.23232C3.35938 10.1224 3.71295 10.976 4.34231 11.6053C4.97168 12.2347 5.82528 12.5883 6.71534 12.5883H19.3002",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryRightArrow);
export default __webpack_public_path__ + "static/media/categoryRightArrow.3ef3bdcf6207d595a4768459c83c150a.svg";
export { ForwardRef as ReactComponent };